import React from 'react';
import {connect} from 'react-redux';
import {TextField as PolarisTextField} from '@shopify/polaris';
import Input from './input';

class TextArea extends Input {
  _render() {
    const {input} = this.props;
    const {error} = input;

    return (
      <PolarisTextField
        id={input.handle}
        type="text"
        label={input.label}
        helpText={renderHelpText(input.helpText)}
        placeholder={input.placeholder}
        onChange={this.handleChange}
        value={input.value}
        multiline={4}
        max={255}
        error={error}
      />
    );
  }
}

function renderHelpText(helpText) {
  return helpText ? (
    <span dangerouslySetInnerHTML={{__html: helpText}} />
  ) : null;
}

export default connect(
  TextArea.mapStateToProps,
  TextArea.mapDispatchToProps
)(TextArea);
